// src/pages/HomePage.jsx

import { Helmet } from "react-helmet";

// Import your existing components
import Hero from "../components/Hero";
import WorkFlow from "../components/WorkFlow";
import Campaigns from "../components/Campaigns";
import Features from "../components/Features";
import WhyChooseUs from "../components/WhyChooseUs";
import AboutSection from "../components/AboutSection";
import Testimonials from "../components/Testimonials";
import Categories from "../components/Category";

function HomePage() {
  return (
    <>
      <Helmet>
        <title>DonatePe - The Leader in Online Fundraising</title>

        <meta
          name="description"
          content="DonatePe is a trusted platform to raise funds for medical, personal, and social causes. Start fundraising or donate easily and securely."
        />

        <meta
          name="keywords"
          content="donate, crowdfunding, fundraising India, charity, donatepe"
        />

        {/* Open Graph (for social sharing) */}
        <meta property="og:title" content="DonatePe - Online Fundraising Platform" />
        <meta
          property="og:description"
          content="Raise funds for causes you care about or support others through DonatePe."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://donatepe.org/" />
      </Helmet>

      <Hero />
      <WorkFlow />
      <Campaigns />
      <Features />
      <WhyChooseUs />
      <AboutSection />
      <Testimonials />
      <Categories />
    </>
  );
}

export default HomePage;